<template>
  <div>
    <!-- 产品列表 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>财务报表</el-breadcrumb-item>
      <el-breadcrumb-item>日历统计</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="conentBox">
      <el-row class="conentRow">
        <div>
          <el-date-picker
            v-model="value1"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
          <el-button type="primary" plain @click="btns">
              查询
          </el-button>
        </div>
        <div>
            <el-button type="primary" plain @click="addProFn()">
                导出
            </el-button>
        </div>
      </el-row>
      <span class="txts">预约时间统计数量 : {{orderNum}}</span>

      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :header-cell-style="tableHeaderColor"
        v-loading="loading"
        :cell-style="cellStyle">
        <el-table-column prop="ScenicID" label="景区ID" ></el-table-column>
        <el-table-column  label="产品名称" width="200">
            <template slot-scope="scope">
              <span>{{scope.row.OrderAll.productname}}</span>
            </template>
        </el-table-column>
        <el-table-column prop="OrderNumber" label="订单编号" width="180"></el-table-column>
        <el-table-column prop="OrderCode" label="验证码" ></el-table-column>
        <el-table-column prop="ActFee" label="支付金额" ></el-table-column>
        <el-table-column prop="Mobile" label="手机号" ></el-table-column>
        <el-table-column prop="CreateTime" label="下单时间" width="160"></el-table-column>
        <el-table-column prop="playdate" label="游玩日期" ></el-table-column>
        <el-table-column prop="Count" label="下单数量" ></el-table-column>
        <el-table-column prop="UseCount" label="使用数量" ></el-table-column>
        <el-table-column prop="CancleCount" label="退款数量" ></el-table-column>
        <el-table-column  label="是否可退" >
            <template slot-scope="scope">
              <span>{{scope.row.returnflag=='1'?'不可退':'可退'}}</span>
            </template>
        </el-table-column>
        
      </el-table>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="demonstration">共{{data.total}}条记录，</span>
        <span class="demonstration">当前显示第{{data.page}}页</span>
        <el-pagination background layout="prev, pager, next" :total="data.total" :current-page="data.page"  @current-change="currenchange" ></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-card>

  </div>
</template>

<script>
import {cldOrderCount,cldOrderCountExport} from '@/request/scenic.js'
import { MessageBox } from 'element-ui';
export default {
  data() {
    return {
      pxvisible: false, // 排序弹框
      addProvisible:false, // 添加产品
      tableData: [
      ],
      imgXlb: require("@/images/scenic/sj.png"),
      options: [
        {
          value: "0",
          label: "上线"
        },
        {
          value: "1",
          label: "下线"
        }
      ],
      value: "",
      data:{
        token:window.sessionStorage.getItem('Token'),
        start_time:'',
        end_time:'',
        page:1,
        page_size:8,
        total:0
      },
      orderNum:0,
      value1:'',
      loading:true
    };
  },
  created(){
    this.value1 = [this.getTodayTime(),this.getTodayTime()]
    if(this.value1){
      this.data.start_time = this.value1[0] 
      this.data.end_time = this.value1[1] 
    }else{
      this.data.start_time = ''
      this.data.end_time = ''
    }
    this.getList()
  },
  methods: {
    getTodayTime() {
      var day = new Date();
      let seconds = day.getSeconds();
      if (seconds < 10) { // 如果月份值小于10，则在前面加上0
        seconds = "0" + seconds;
      } else {
        seconds = seconds;
      }
      let minutes = day.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes;
      } else {
        minutes = minutes;
      }
      let month = day.getMonth()
      if (month < 10) {
      month = "0" + month;
      }
      let time = day.getFullYear() + "-" + (day.getMonth() + 1) + "-" + day.getDate() 
      return time
    },
    btns(){
      this.loading = true
      if(this.value1){
        this.data.start_time = this.value1[0] 
        this.data.end_time = this.value1[1] 
      }else{
        this.data.start_time = ''
        this.data.end_time = ''
      }
      this.data.total = 0
      this.data.page  = 1
      this.getList()
    },

    // 获取产品列表数据
    getList(){
      cldOrderCount(this.data).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.order.data
          this.data.total = res.data.result.order.total
          this.orderNum = res.data.result.order_num[0].order_num
          this.loading = false
        }
      })
    },
    // 分页
    currenchange(e){
      this.data.page = e
      this.getList()
    },
    // 导出产品
    addProFn() {
      if(this.value1){
        this.data.start_time = this.value1[0] 
        this.data.end_time = this.value1[1] 
      }else{
        this.$message.error('请选择时间后导出')
        return false
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        start_time:this.data.start_time ,
        end_time:this.data.end_time,
      }
      cldOrderCountExport(data).then(res=>{
        console.log(res)
        if(res.data.rcode==200){
          window.location.href = res.data.result
        }
      })
    },
   
 
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
/deep/.el-card__body {
  padding: 0 20px;
}
.conentBox {
  margin-top: 17px;
  .conentRow {
    margin: 20px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    > div:nth-child(1) {
      // width: 50%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      ::v-deep .el-button{
        height: 4rem;
        margin-left: 2rem;
      }
      
    }
    > div:nth-child(2) {
      // width: 50%;
      display: flex;
      justify-content: flex-end;
      margin-bottom: 10px;
      margin-left: auto;
      .scenicBtnDel {
        .el-button {
          width: 92px;
          background: #ffffff;
          border: 1px solid #ff4d4f;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          color: #ff4d4f;
          box-sizing: border-box;
        }
      }
      .scenicBtnPx {
        margin: 0 20px;
        .el-button {
          background: #ffffff;
          border: 1px solid #246deb;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          /* identical to box height */
          box-sizing: border-box;
          color: #246deb;
        }
      }
      .scenicBtn {
        .el-button {
          width: 120px;
          background: #ffffff;
          border: 1px solid #246deb;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          box-sizing: border-box;
          color: #246deb;
        }
      }
    }
  }
}

/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4ecb73;
  border-color: #4ecb73;
}

/deep/.el-dialog__header {
  // height: 60px;
  // line-height: 60px;
  // padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}

// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
::v-deep .el-popover__reference{
  color: #FF4D4F;
  margin-right: 1.9rem;
  cursor: pointer;
}
.cursor{
  cursor: pointer;
}
.conentRow /deep/ .el-button{
  color: #fff;
  background: #246deb;
}
/deep/ .el-table th, /deep/.el-table td{
  text-align:left !important;
}
.txts{
  color: #246deb;
  font-size: 1.8rem;
  display: block;
  margin-bottom: 1.2rem;
}
</style>